"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { getCreateWaveNextStep, getCreateWavePreviousStep } from "@/helpers/waves/create-wave.helpers";
import type { CreateWaveConfig, CreateWaveStep } from "@/types/waves.types";
import CreateWaveBackStep from "./CreateWaveBackStep";
import CreateWaveNextStep from "./CreateWaveNextStep";
export default function CreateWaveActions(t0) {
  const $ = _c(24);
  const {
    config,
    step,
    submitting,
    setStep,
    onComplete
  } = t0;
  let t1;
  if ($[0] !== config.overview.type || $[1] !== onComplete || $[2] !== setStep || $[3] !== step) {
    t1 = async () => {
      const nextStep = getCreateWaveNextStep({
        step,
        waveType: config.overview.type
      });
      if (nextStep) {
        setStep(nextStep, "forward");
        return;
      }
      await onComplete();
    };
    $[0] = config.overview.type;
    $[1] = onComplete;
    $[2] = setStep;
    $[3] = step;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onNextStep = t1;
  let t2;
  if ($[5] !== config.overview.type || $[6] !== step) {
    t2 = getCreateWavePreviousStep({
      step,
      waveType: config.overview.type
    });
    $[5] = config.overview.type;
    $[6] = step;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const [previousStep, setPreviousStep] = useState(t2);
  let t3;
  let t4;
  if ($[8] !== config.overview.type || $[9] !== step) {
    t3 = () => setPreviousStep(getCreateWavePreviousStep({
      step,
      waveType: config.overview.type
    }));
    t4 = [step, config.overview.type];
    $[8] = config.overview.type;
    $[9] = step;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] !== previousStep || $[13] !== setStep) {
    t5 = previousStep && <CreateWaveBackStep onPreviousStep={() => setStep(previousStep, "backward")} />;
    $[12] = previousStep;
    $[13] = setStep;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <div className="-tw-ml-6">{t5}</div>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== onNextStep || $[18] !== step || $[19] !== submitting) {
    t7 = <div className="tw-ml-auto"><CreateWaveNextStep onClick={onNextStep} disabled={false} step={step} submitting={submitting} /></div>;
    $[17] = onNextStep;
    $[18] = step;
    $[19] = submitting;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <div className="tw-mt-4 md:tw-mt-6 tw-flex tw-gap-x-4 tw-items-center tw-justify-between">{t6}{t7}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}